// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"afb7a00a","382":"afb7a00a","925":"afb7a00a"}[chunkId] + ".chunk.css";
};